module.exports = __webpack_public_path__ + "media/pota.d2f693f3.mp4";